<template>
  <div class="listable">
    <template v-if="!!items && items.length > 0">
      <TableHeaders
        :columns="columns"
        :active="activeColumns"
        :hasDetailsPane="hasDetailsPane"
        :hideMenus="hideHeaderMenus"
        :swappable="swappableColumns"
        @sort-by="sortBy"
        @swap-column="swapColumn"
      />
      <div v-for="(item, i) in items" :key="i" class="listable-data">
        <slot name="list-card" :item="item" :id="`list-card-${i}`" />
        <template v-for="(slug, i) in activeColumns">
          <div
            :key="slug"
            @click="$emit('item-clicked', item)"
            class="td"
            :class="{ 'd-none': i > 2 && hasDetailsPane }"
          >
            <slot :name="`col_${slug}`" :item="item">{{
              columnValue(item, slug)
            }}</slot>
          </div>
        </template>
        <div class="td text-right">
          <slot name="list-menu" :item="item" :id="`list-menu-${i}`" />
        </div>
      </div>
    </template>
    <div v-else-if="!hideNoResults" class="alert alert-info text-center">
      <p class="m-0">No results found. Try broadening your search.</p>
    </div>
  </div>
</template>

<script>
import TableHeaders from "./TableHeaders";
export default {
  components: { TableHeaders },
  props: {
    columns: { type: Array, required: true },
    activeColumns: { type: Array, required: true },
    swappableColumns: { type: Boolean, default: true },
    items: { type: Array },
    hasDetailsPane: { type: Boolean, default: false },
    hideNoResults: { type: Boolean, default: true },
    hideHeaderMenus: { type: Boolean, default: false },
  },
  methods: {
    columnValue(item, column) {
      var value = item;
      var segments = column.split(".");
      for (var i in segments) {
        var segment = segments[i];
        if (
          typeof value === "object" &&
          value.hasOwnProperty(segment) &&
          value[segment] !== null
        ) {
          value = value[segment];
          if (typeof value === "boolean") {
            value = !!value ? "Yes" : "No";
          }
        } else {
          return "";
        }
      }
      return value;
    },
    sortBy(column, dir) {
      this.$emit("sort-by", column, dir);
    },
    swapColumn(column, index) {
      this.$emit("swap-column", column, index);
    },
  },
};
</script>
